// PDF.js wrapper — replaces the native PdfiumViewer + PdfPig stack.
import * as pdfjsLib from 'pdfjs-dist'
import workerUrl from 'pdfjs-dist/build/pdf.worker.min.mjs?url'

pdfjsLib.GlobalWorkerOptions.workerSrc = workerUrl

export type PdfDocument = pdfjsLib.PDFDocumentProxy
export type PdfPage = pdfjsLib.PDFPageProxy

export async function loadPdf(data: ArrayBuffer): Promise<PdfDocument> {
  // getDocument detaches the buffer, so hand it a private copy.
  const bytes = new Uint8Array(data.slice(0))
  const task = pdfjsLib.getDocument({ data: bytes })
  return task.promise
}

export { pdfjsLib }
